import { HRISConnectorType } from './types';

export class SyncConnectorError extends Error {
	public connectorType: HRISConnectorType;
	constructor(message: string, connectorType: HRISConnectorType) {
		super(message);
		this.name = 'SyncConnectorError';
		this.connectorType = connectorType;
	}
}

export class DisconnectConnectorError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'DisconnectConnectorError';
	}
}
